import React from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import PageHeader from "../../../components/PageHeader";
import {apiCall} from "../../../helpers/MainHelper";
import ReactLoading from "react-loading";

class LowStockReport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            warehouses: [],
            filters: {
                warehouse_id: ''
            },
            reportData: [],
            hasGenerated: false
        }
    }

    componentDidMount() {
        this.fetchWarehouses();
    }

    fetchWarehouses = async () => {
        try {
            const response = await apiCall('business/stock/warehouse/select-list','get');
            this.setState({warehouses: response.data || []});
        } catch (e) {
            console.error(e);
        }
    }

    handleFilterChange = (e) => {
        const {name, value} = e.target;
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                [name]: value
            }
        }));
    }

    generateReport = async () => {
        this.setState({loading: true});
        try {
            const response = await apiCall('business/stock/report/low-stock','post', JSON.stringify(this.state.filters), {
                'Content-Type': 'application/json'
            });
            if(response.status === 'success') {
                this.setState({
                    reportData: response.data || [],
                    hasGenerated: true
                });
            }
        } catch (e) {
            console.error(e);
            this.setState({hasGenerated: true});
        }
        this.setState({loading: false});
    }

    render() {
        const {loading, warehouses, filters, reportData, hasGenerated} = this.state;

        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Düşük Stok Raporu"
                            Breadcrumb={[
                                { name: "Stok Yönetimi", navigate: "" },
                                { name: "Raporlar", navigate: "" },
                                { name: "Düşük Stok", navigate: "" },
                            ]}
                        />

                        {/* Filtreler */}
                        <div className="row clearfix">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="header">
                                        <h2>Filtreler</h2>
                                    </div>
                                    <div className="body">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Depo</label>
                                                    <select
                                                        name="warehouse_id"
                                                        className="form-control"
                                                        value={filters.warehouse_id}
                                                        onChange={this.handleFilterChange}
                                                    >
                                                        <option value="">Tüm Depolar</option>
                                                        {warehouses.map(warehouse => (
                                                            <option key={warehouse.id} value={warehouse.id}>
                                                                {warehouse.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>&nbsp;</label>
                                                    <button
                                                        className="btn btn-primary btn-block"
                                                        onClick={this.generateReport}
                                                        disabled={loading}
                                                        style={{textAlign: "-webkit-center"}}>

                                                        {loading ? <ReactLoading type="spin" width={'20px'} height={'20px'} /> : 'Rapor Oluştur'}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Rapor Sonuçları */}
                        {hasGenerated && reportData.length > 0 && (
                            <div className="row clearfix">
                                <div className="col-lg-12">
                                    <div className="card">
                                        <div className="header">
                                            <h2>Düşük Stoklu Ürünler <small className="text-danger">{reportData.length} uyarı</small></h2>
                                        </div>
                                        <div className="body">
                                            <div className="table-responsive">
                                                <table className="table table-hover table-vcenter mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th>Depo</th>
                                                            <th>Stok Kalemi</th>
                                                            <th>SKU</th>
                                                            <th className="text-right">Mevcut Stok</th>
                                                            <th className="text-right">Min. Stok</th>
                                                            <th className="text-right">Eksiklik</th>
                                                            <th className="text-center">Durum</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {reportData.map((item, index) => (
                                                            <tr key={index}>
                                                                <td><small>{item.warehouse_name}</small></td>
                                                                <td><strong>{item.stock_item_name}</strong></td>
                                                                <td><small>{item.sku || '-'}</small></td>
                                                                <td className="text-right">
                                                                    <span className={item.current_stock === 0 ? 'text-danger' : 'text-warning'}>
                                                                        <strong>{item.current_stock}</strong>
                                                                    </span>
                                                                </td>
                                                                <td className="text-right"><small>{item.min_stock_level}</small></td>
                                                                <td className="text-right text-danger">
                                                                    <strong>{item.shortage}</strong>
                                                                </td>
                                                                <td className="text-center">
                                                                    {item.current_stock === 0 ? (
                                                                        <span className="badge badge-danger">Stok Tükendi</span>
                                                                    ) : (
                                                                        <span className="badge badge-warning">Düşük Stok</span>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Veri Yok Uyarısı */}
                        {!loading && hasGenerated && reportData.length === 0 && (
                            <div className="row clearfix">
                                <div className="col-lg-12">
                                    <div className="card">
                                        <div className="body">
                                            <div className="alert alert-success text-center mb-0">
                                                <i className="icon-check" style={{fontSize: '48px', display: 'block', marginBottom: '15px', color: '#28a745'}}></i>
                                                <h4>Harika! Düşük Stok Bulunmuyor</h4>
                                                <p>Seçili filtreler için minimum stok seviyesinin altında ürün bulunamadı.</p>
                                                <small className="text-muted">Tüm ürünlerin stok seviyeleri yeterli görünüyor.</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* İlk Yükleme Mesajı */}
                        {!loading && !hasGenerated && (
                            <div className="row clearfix">
                                <div className="col-lg-12">
                                    <div className="card">
                                        <div className="body">
                                            <div className="alert alert-info text-center mb-0">
                                                <i className="icon-bell" style={{fontSize: '48px', display: 'block', marginBottom: '15px', color: '#17a2b8'}}></i>
                                                <h4>Rapor Oluşturun</h4>
                                                <p>Düşük stoklu ürünleri görüntülemek için "Rapor Oluştur" butonuna tıklayın.</p>
                                                <small className="text-muted">Minimum stok seviyesinin altındaki tüm ürünler listelenecektir.</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({stockReducer}) => ({});

export default withRouter(connect(mapStateToProps, {})(LowStockReport));




